var map = {
	"./de": [
		"0b1f",
		"lang-de"
	],
	"./de.ts": [
		"0b1f",
		"lang-de"
	],
	"./en": [
		"ea98",
		"lang-en"
	],
	"./en.ts": [
		"ea98",
		"lang-en"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ac31";
module.exports = webpackAsyncContext;